import { deepInterop, deepInteropFactory, evalFactory, tryEval } from "../../lib/utils/stringInterop";
import FlowAbortError from './FlowAbortError';
import { assign, set } from "lodash-es";
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
export function compileFlow(flow, contextBase) {
  const {
    atoms,
    interopContext
  } = contextBase;
  flow.steps.forEach(step => {
    const atom = atoms[step.type];
    if (!atom) throw new Error(`准备Flow失败，没有ID为${step.type}的Atom`);
  });
  // eslint-disable-next-line max-len
  return executeOptions => new Promise((resolve, reject) => {
    if (!executeOptions) reject(new Error('执行Flow失败，没有输入initial state'));
    const args = executeOptions.arguments || [];
    const ctxBase = {
      ...contextBase,
      lastAtomResult: undefined,
      atoms,
      flow,
      index: 0,
      state: {
        ...executeOptions.state
      },
      args,
      arguments: args,
      $event: args[0],
      flowStatus: 'in-progress',
      abort() {
        aborted = true;
      },
      extraInteropContext: null,
      tryEval(expr) {
        return tryEval(expr, ctxBase.interopContext, ctxBase.extraInteropContext);
      }
    };
    ctxBase.extraInteropContext = {
      flow: ctxBase,
      flowState: ctxBase.state,
      $event: ctxBase.$event
    };
    let aborted = false;
    (async function runAtom() {
      const step = aborted ? null : ctxBase.flow.steps[ctxBase.index];
      if (!step) {
        ctxBase.index -= 1;
        ctxBase.flowStatus = aborted ? 'aborted' : 'finished';
        if (aborted) {
          reject(new FlowAbortError(ctxBase));
        } else {
          resolve(ctxBase);
        }
        return;
      }
      const {
        type: id
      } = step;
      const atom = atoms[id];
      try {
        let shallRun = !step.disabled;
        try {
          // eslint-disable-next-line max-len
          shallRun = shallRun && (!step.condition || !!evalFactory({
            throwError: true
          })(step.condition, ctxBase.interopContext, ctxBase.extraInteropContext));
        } catch (e) {
          set(ctxBase, 'state.evalErrors._condition', e);
          shallRun = false;
        }
        if (shallRun) {
          const finalParams = {
            ...atom.defaultParams,
            ...step.params
          };
          const process = (val, field, id, {
            throwError
          }) => {
            if (field['uc:allowExpr'] && isExprObject(val)) {
              finalParams[id] = evalFactory({
                throwError
              })(val.$expr, interopContext, ctxBase.extraInteropContext);
            } else if (field['uc:allowInterop']) {
              finalParams[id] = deepInteropFactory({
                throwError
              })(val, interopContext, ctxBase.extraInteropContext);
            }
          };
          atom.paramsSchema.fields.forEach(field => {
            const id = field.id;
            const val = finalParams[id];
            try {
              process(val, field, id, {
                throwError: true
              });
            } catch (e) {
              set(ctxBase, `state.evalErrors.${id}`, e);
              // 插值表达式重新计算
              if (!(field['uc:allowExpr'] && isExprObject(val)) && field['uc:allowInterop']) {
                process(val, field, id, {
                  throwError: false
                });
              }
            }
          });
          try {
            // 如果有自定义报错模版, 则编译时的错误也会被捕获并抛出,并终止后续流程
            if (step.errMsgTpl) {
              const [fieldId, err] = Object.entries(ctxBase.state.evalErrors || {})[0] || [];
              if (err && fieldId) throw new Error(`${fieldId}计算出错: ${err.message}`);
            }
            const result = await atom.execute({
              ...ctxBase
            }, finalParams);
            ctxBase.lastAtomResult = result;
            // 解构拍平进flowState
            if (step.params.flowStatePass) assign(ctxBase.state, result);
            if (step.backfill) ctxBase.state[step.backfill] = result;
          } catch (e) {
            try {
              if (step.errMsgTpl) {
                var _ctxBase$uc;
                const logger = (_ctxBase$uc = ctxBase.uc) === null || _ctxBase$uc === void 0 ? void 0 : _ctxBase$uc.config.flowErrorLogger;
                const errMsg = deepInterop(step.errMsgTpl, interopContext, ctxBase.extraInteropContext, {
                  error: e
                });
                errMsg && (logger === null || logger === void 0 ? void 0 : logger.error(errMsg));
              }
            } catch (e) {}
            throw e;
          }
        }
        ctxBase.index += 1;
        runAtom();
      } catch (e) {
        ctxBase.flowStatus = 'error';
        if (typeof e === 'object' && e) {
          try {
            e.flowCtx = ctxBase; // 如果 throw 出來的是一個對象，則挂载 ctxBase 以便调试
          } catch (_unused) {
            // ignore
          }
        }
        reject(e);
      }
    })();
  });
}